export default __webpack_public_path__ + "assets/link_widget.1da07d794bb934b520b7e617910bc8b0.svg";